import { PerkDefinition } from "./types";

export const perkHp = {
  id: "perk_hp",
  name: "Vitality Up",
  description: "+5 Max HP (and heal the gain).",
  apply: ({ addMaxHp, healActor }) => {
    addMaxHp(5);
    healActor(5);
  },
} satisfies PerkDefinition<"perk_hp">;
